import React, { ChangeEvent, memo } from 'react';
import { Input as AntdInput } from 'antd';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

export interface InputProps {
	value: string;
	placeholder: string;
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
	label?: string;
	dataTestId?: string;
}

const Input = ({ value, placeholder, onChange, label, dataTestId }: InputProps) => {
	return (
		<div className="filter-item filters-search" data-test-id={dataTestId}>
			{label && <label className="filters-search-label">{label}:</label>}
			<AntdInput
				value={value}
				suffix={<BringgIcon iconName={BringgFontIcons.Search} />}
				placeholder={placeholder}
				onChange={onChange}
			/>
		</div>
	);
};

export default memo(Input);
